var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{class:_vm.$store.state.userParameters.inApp ? 'flex-content main-in-app' : 'flex-content'},[_c('svg-container'),_vm._v(" "),(!_vm.$store.state.userParameters.inApp)?_c('navbar'):_vm._e(),_vm._v(" "),_c('router-view')],1),_vm._v(" "),_c('page-footer',{attrs:{"brand":_vm.$store.state.userParameters.inApp}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3089735a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 